import { render } from "./maison-image-text.vue?vue&type=template&id=265c9c26&scoped=true"
import script from "./maison-image-text.vue?vue&type=script&lang=js"
export * from "./maison-image-text.vue?vue&type=script&lang=js"

import "./maison-image-text.vue?vue&type=style&index=0&id=265c9c26&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265c9c26"]])

export default __exports__